import { configureStore, ReducersMapObject, StateFromReducersMapObject } from '@reduxjs/toolkit';
import { freqLimitMiddleware } from './middleware/freqLimitMiddleware';
import { isTestEnv } from '../config';

const reducer: ReducersMapObject<{}> = {};

export type RootState = StateFromReducersMapObject<typeof reducer>;

export const store = configureStore({
  devTools: isTestEnv && {
    name: 'TCCC-SDK',
  },
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([freqLimitMiddleware]),
});
export type AppDispatch = typeof store.dispatch;
